(function(SCS) {
	'use strict';

	var search = SCS.search = SCS.search || {};

	function fixupStartValue() {
		// Fix up start value offset for Web vs. GSA (Web starts at 1, GSA at 0)
		return function startValueFixerUpper(config, callback) {
			if('start' in config.params) {
				config.params.start = config.params.start + 1;
			}
			callback();
		};
	}

	function fixupResult() {
		// Unify the data structure to be mostly compatible with what we get from the GSA
		return function resultFixerUpper(data, config, callback) {
			data = search.util.extend({}, data);
			var results = data.results = data.items || data.results || [];
			data.resultCount = (data.searchInformation && parseInt(data.searchInformation.totalResults, 10)) || data.resultCount || results.length || 0;
			callback(data);
		};
	}

	function setUp(processor, startValueFixerUpper, resultFixerUpper) {
		processor.usePre(startValueFixerUpper||fixupStartValue(), 1000500);
		processor.usePost(resultFixerUpper||fixupResult());
	}

	var plugins = search.plugins = search.plugins || {};
	var web = plugins.web = plugins.web || {};

	web.fixupStartValue = fixupStartValue;
	web.fixupResult = fixupResult;
	web.setUp = setUp;

})(window.SCS = window.SCS || {});


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/plugins/web.js
// module id = 305
// module chunks = 0